export default "__VITE_ASSET__BbLPcVhh__"